import * as echarts from 'echarts';
import { EChartsType } from 'echarts';
import { ECBasicOption } from 'echarts/types/dist/shared';
import { useEffect, useRef } from "react";
import { getChart, useChart } from '../../../../../contexts/ChartContext';
import { colorOfYAxis } from '../constants';

interface IProps {
    className?: string
    xAxis: any
    series: any
    yLine: any
    id?: string
}

const LineChart: React.FC<IProps> = (props) => {
    const lineRef = useRef<HTMLDivElement>(null);
    const lineChart = useRef<EChartsType>();
    const { xAxis = {}, yLine, series, id } = props;
    const [dataIndex, set] = useChart(state => state.dataIndex);
    const get = getChart();
    const idRef = useRef<string>(id || "");

    useEffect(() => {
        if (lineRef.current) {
            const existInstance = echarts.getInstanceByDom(lineRef.current);
            if (existInstance) {
                echarts.dispose(lineRef.current)
            };
            lineChart.current = echarts.init(lineRef.current);
            lineChart.current?.on('updateAxisPointer', (e: any) => {
                const { dataIndex } = e;
                const { hoverId } = get();
                if (hoverId === idRef.current)
                    set({ dataIndex });
            });
            const hide = () => {
                set({ dataIndex: undefined, hoverId: undefined });
            };
            lineChart.current?.on('mouseout', hide);
            lineChart.current?.on('globalout', hide);
        }
    }, [get, set]);

    useEffect(() => {
        const { hoverId } = get();
        if (hoverId === undefined) {
            lineChart.current?.dispatchAction({ type: 'hideTip' });
            return;
        }
        if (hoverId === idRef.current) {
            return;
        }
        const seriesCurrent: any[] = (lineChart.current?.getOption() as any)?.series || [];
        if (seriesCurrent.length > 0) {
            const max = seriesCurrent[0].data.length - 1;
            const currentIndex = Math.min(dataIndex || 0, max);
            const seriesIndex = (seriesCurrent as any[]).findIndex(item => item.data[currentIndex] !== null);
            lineChart.current?.dispatchAction({
                type: 'showTip',
                seriesIndex,
                dataIndex: currentIndex,
            });
        }

    }, [dataIndex, get])

    useEffect(() => {
        if (!!lineChart) {

            let i = 0;
            const option: ECBasicOption = {
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    top: '5px',
                    right: '20px',
                    bottom: '30px'
                },
                xAxis: {
                    ...xAxis,
                    axisLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                },
                yAxis: Object.keys(yLine).length > 0 ? Object.keys(yLine).map((key) => {
                    const value = {
                        type: 'value',
                        name: '',
                        position: 'left',
                        offset: colorOfYAxis[key] ? (50 * i) : 0,
                        alignTicks: true,
                        axisLabel: {
                            formatter: (value: number) => Math.round(value * 1000) / 1000
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: colorOfYAxis[key]
                            }
                        }
                    };
                    if (colorOfYAxis[key])
                        i++;
                    return value
                }) : { type: 'value' },
                series
            };
            lineChart.current?.setOption(option, true);
        }
    }, [series, yLine, xAxis]);

    return <div ref={lineRef} className={props.className} onMouseMove={() => set({ hoverId: idRef.current })} />
}

export default LineChart